import type React from 'react';

import { Banner } from '#src/app/shared/components/banners/layout';

export const EmergencyBanner: React.FC<{ emergencyBanner: string }> = ({ emergencyBanner }) => {
	return <Banner mobileContent={emergencyBanner} desktopContent={emergencyBanner} />;
};
